import { render, staticRenderFns } from "./open_orders.vue?vue&type=template&id=0db5c734&scoped=true&"
import script from "./open_orders.vue?vue&type=script&lang=js&"
export * from "./open_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5c734",
  null
  
)

export default component.exports